import React from 'react';

export const Archive = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.2197 6H7.78029C7.15276 6 6.55794 6.27994 6.158 6.76351L1.48297 12.416C1.17079 12.7935 1 13.268 1 13.7578V18.8947C1 20.0574 1.94256 21 3.10526 21H20.8947C22.0574 21 23 20.0574 23 18.8947V13.7578C23 13.268 22.8292 12.7935 22.517 12.416L17.842 6.76351C17.4421 6.27994 16.8472 6 16.2197 6Z"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M1 12.803H7.54054V15.776H17.054V12.803H23"
      stroke="black"
      strokeWidth="1.5"
    />
    <path d="M12.4831 2L12.4831 12" stroke="black" strokeWidth="1.5" />
    <path
      d="M8.96618 9.31309L12.4831 12.83L16 9.3131"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
